<template>
    <div class="bg ">
        <div class="logo_wrap ">
            <!-- <div class="logo"></div>
            <div class="logo_right">
                <div class="power">Powered by MVGX</div>
                <div class="right_top_txt_shu">|</div>
                <Kefu :sn="sn"></Kefu>
            </div> -->
        </div>
        <div class="content m_rl_20">
            <div class="content_title">
                <img src="../assets/img/error.png" alt="" class="error">
            </div>
            <div class="content_con">
                <!--  -->
                <!-- <p>It looks like you're using a new browser, and we're unable to recognize your previous session. Please contact the event organizer to request a new access link.
                </p> -->
                <p>{{ $t('Itlooks') }}
                </p>
                <!-- <p>Please use this browser to access the link again: <a href="https://netzero.test.mvgx.com/active?active=2218">https://netzero.test.mvgx.com/active?active=2218</a></p> -->
                <!--  -->
                <!-- <p v-if="type == 2">This Card Has Already Been Used To Neutralize Carbon Footprint</p>
                <p v-if="type == 3">This Card Has Been Suspended!</p>
                <p v-if="type == 4">This Card Has Already Expired!</p>
                <p v-if="type == 5">The address has expired and cannot be accessed</p> -->
                <!-- <p  style="margin-bottom:1.25rem">Thank You For Your Effort To Neutralize Your Carbon Footprint !</p>
                <span >Our Earth Needs Your Help ! </span> -->
            </div>

        </div>
        <div class=" please">
            <!-- Please visit 
            <a href="https://www.mvgx.com/">https://www.mvgx.com/ </a>
            for more information about our products  -->
        </div>
        <div class="m_rl_20">
            <!-- <a href="https://www.mvgx.com/"> -->
            <el-button class="btn" @click="close()">{{ $t('Close') }}</el-button>
            <!-- </a> -->
        </div>
    </div>
</template>

<script>
import cnt from '@/api/cnt'
import Kefu from '@/components/kefu.vue'
export default {
    name: 'carsuccess',
    // import引入的组件需要注入到对象中才能使用
    components: { Kefu },
    data() {
        // 这里存放数据
        return {
            sn: '',
            type: '',
            config: '',
        }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.sn = this.$route.query.sn;
        this.type = this.$route.query.type;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //   this.getUserEvent(1,1)
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
    // 方法集合
    methods: {
        close() {
            window.opener = null;
            window.open("about:blank", "_top").close()
        },
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
    }
}
</script>
<style lang="less" scoped>
a {
    color: #ffffff;
    text-decoration: none;
}

.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    background: url("../assets/img/bj.png") no-repeat;
    background-size: 100% 100%;
}

.logo_wrap {
    margin: 1.25rem 1.25rem 2.1875rem;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .logo {
        width: auto;
    }

    .logo_right {
        display: flex;
        align-items: center;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }

    .power {
        font-size: .75rem;
        font-family: Century Gothic;
        color: #EDFFFE;
    }
}

.content {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(.3125rem);
    padding: 3.0625rem 0;
    text-align: center;
    color: #fff;
    border-radius: 1.25rem;
}

.error {
    width: 3.375rem;
    height: 3.375rem;
    margin-bottom: 2.0625rem;

}

.content_con {
    margin: 0 1.25rem;
    font-size: .9375rem;
    font-family: Century Gothic;
}

.please {
    margin: 3.75rem 1.25rem 7.25rem;
    font-size: .8125rem;
    font-family: Century Gothic;
    color: #FFFFFF;
    text-align: center;

}

.please>span {
    font-weight: bold;
}

.btn {
    width: 100%;
    height: 2.8125rem;
    color: #4D94A0;
    margin-bottom: 1.3125rem;
    border-radius: .625rem;
    font-size: .9375rem;
    font-family: Century Gothic;
    box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
}
</style>
